// Google Tag Manager configuration from environment variables
const GTM_ID = import.meta.env.VITE_GTM_ID;

/**
 * Consent Mode v2 defaults, denied (APP-1182). Must execute BEFORE {@link gtmScript}: a container
 * that starts with no consent state at all runs GA4 in full mode, which is what this denies.
 *
 * The `gtag(...)` wrapper is load-bearing, not ceremony. It pushes the `arguments` object, and GTM
 * treats only `[object Arguments]` as a consent command — a plain `dataLayer.push(["consent", ...])`
 * array is silently ignored and leaves `google_tag_data.ics` empty.
 */
export const consentDefaultScript = `
window.dataLayer=window.dataLayer||[];
function gtag(){window.dataLayer.push(arguments);}
gtag('consent','default',{ad_storage:'denied',analytics_storage:'denied',ad_user_data:'denied',ad_personalization:'denied',wait_for_update:500});
`;

/**
 * GTM container loader (WEB-88). The `gtm.start` timestamp and `gtm.js` event are pushed to the
 * dataLayer immediately so any event queued before the container arrives is buffered, but the ~325 KB
 * container download is deferred off first paint to `requestIdleCallback` (Safari lacks it, hence the
 * setTimeout fallback — same convention as useGoogleOneTap). Consent Mode defaults still land first:
 * {@link consentDefaultScript} runs inline at parse time, long before this idle callback fires.
 *
 * Trade accepted by the acquisition owner: a visitor who bounces inside the deferral window loads no
 * container, so their pageview reaches neither GA4 nor Google Ads and they miss the remarketing audience.
 */
export const gtmScript = `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});function load(){var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);}
if(typeof w.requestIdleCallback==='function'){w.requestIdleCallback(load,{timeout:3000});}else{w.setTimeout(load,2000);}
})(window,document,'script','dataLayer','${GTM_ID}');
`;

// Google Tag Manager noscript iframe URL
export const gtmNoscriptUrl = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
